module.exports = __webpack_public_path__ + "static/media/Silent.d17fc842.png";